import userApis from "apis/users";
import { setLoading } from "features/auth";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const OrdersAnalytics = () => {
  const jwt = useSelector((state) => state?.auth?.jwt);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [analytics, setAnalytics] = useState({});

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        dispatch(setLoading(true));
        const api = new userApis(jwt);
        const response = await api.getOrdersAnalytics(); // Replace with actual API method
        setAnalytics(response);
        dispatch(setLoading(false));
      } catch (err) {
        toast.error("Failed to fetch analytics. Please try again later.");
      } finally {
        dispatch(setLoading(false));
      }
    };

    fetchAnalytics();
  }, [jwt]);

  const {
    monthlySales,
    yearlySales,
    totalOrders,
    refundedOrders,
    completedOrders,
    totalUsers,
  } = analytics;

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Orders Analytics</h1>
      {!analytics || Object.keys(analytics).length === 0 ? (
        <p>Loading analytics...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Monthly Sales by Places Card */}
          <div className="border p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500">
            <h2 className="text-3xl font-semibold mb-4 text-white">
              Monthly Sales by Places
            </h2>
            <div className="list-disc pl-6 space-y-3">
              {monthlySales &&
                yearlySales.map(([placeId, sales]) => (
                  <p
                    key={placeId}
                    className="text-lg text-white hover:text-yellow-400 transition-colors"
                  >
                    <span className="font-bold text-white-300">
                      {placeId} : Rs. {sales}
                    </span>
                  </p>
                ))}
            </div>
          </div>

          {/* Yearly Sales by Place Card */}
          <div className="border p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl bg-gradient-to-r from-green-400 via-teal-400 to-blue-500">
            <h2 className="text-3xl font-semibold mb-4 text-white">
              Yearly Sales by Place
            </h2>
            <div className="list-disc pl-6 space-y-3">
              {yearlySales &&
                yearlySales.map(([placeId, sales]) => (
                  <p
                    key={placeId}
                    className="text-lg text-white hover:text-yellow-400 transition-colors"
                  >
                    <span className="font-bold text-white-300">
                      {placeId} : Rs. {sales}
                    </span>
                  </p>
                ))}
            </div>
          </div>

          {/* Other Cards */}
          <div
            className="border p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl bg-gradient-to-r from-indigo-500 via-blue-500 to-teal-500"
            onClick={() => navigate("/admin/bookings")}
          >
            <h2 className="text-3xl font-semibold mb-4 text-white">
              Total Bookings
            </h2>
            <p className="text-2xl text-white font-bold">{totalOrders || 0}</p>
          </div>

          <div className="border p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl bg-gradient-to-r from-red-500 via-orange-400 to-yellow-500">
            <h2 className="text-3xl font-semibold mb-4 text-white">
              Refunded Bookings
            </h2>
            <p className="text-2xl text-white font-bold">
              {refundedOrders || 0}
            </p>
          </div>

          <div className="border p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl bg-gradient-to-r from-green-600 via-teal-500 to-blue-600">
            <h2 className="text-3xl font-semibold mb-4 text-white">
              Completed Orders
            </h2>
            <p className="text-2xl text-white font-bold">
              {completedOrders || 0}
            </p>
          </div>

          <div
            className="border p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl bg-gradient-to-r from-purple-500 via-indigo-500 to-blue-500"
            onClick={() => navigate("/admin/users")}
          >
            <h2 className="text-3xl font-semibold mb-4 text-white">
              Total Users
            </h2>
            <p className="text-2xl text-white font-bold">{totalUsers || 0}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrdersAnalytics;
